import { UserSummary } from './User';

export type CommentId = string;

export type CommentSubjectType = 'memo' | 'media';

export type CommentSubject = {
  type: CommentSubjectType;
  id: string;
};

export interface Comment {
  id: CommentId;
  content: string;
  author: UserSummary;
  parentId?: CommentId;
  replyCount: number;
  replies?: Comment[];
  updatedAt: string;
  createdAt: string;
}

// The comment's content changed after posting: what an "edited" tag keys off.
export const isCommentEdited = (comment: Comment): boolean =>
  Date.parse(comment.updatedAt) > Date.parse(comment.createdAt);

// Conversation size across a listing: every top-level comment plus its
// replies, without the replies having been fetched.
export const conversationCount = (comments: Comment[]): number =>
  comments.reduce((total, comment) => total + 1 + comment.replyCount, 0);

// Whether the listing holds a comment (or a fetched reply) by the given user.
// Unfetched replies can't count: listings only carry their number.
export const hasCommentBy = (comments: Comment[], userId?: string): boolean =>
  !!userId &&
  comments.some(
    (comment) =>
      comment.author.id === userId ||
      (comment.replies ?? []).some((reply) => reply.author.id === userId),
  );
